import { render, staticRenderFns } from "./promoterStats.vue?vue&type=template&id=6fa55dee&scoped=true&"
import script from "./promoterStats.vue?vue&type=script&lang=js&"
export * from "./promoterStats.vue?vue&type=script&lang=js&"
import style0 from "./promoterStats.vue?vue&type=style&index=0&id=6fa55dee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa55dee",
  null
  
)

export default component.exports